import React, { useEffect, useState, useContext } from "react";
import { LanguageContext } from "App";
import { calculateDateRange } from "./dateHelpers";

const QuickDatePicker = ({
  style,
  setFrom,
  setTo,
  className,
  reset,
  future,
}) => {
  const { translations } = useContext(LanguageContext);
  const [quickDate, setQuickDate] = useState("All Time");

  const commonOptions = [
    { value: "Today", label: translations.qdToday },
    { value: "This Week", label: translations.qdThisWeek },
    { value: "This Month", label: translations.qdThisMonth },
    { value: "This Year", label: translations.qdThisYear },
  ];

  const pastOptions = [
    { value: "Yesterday", label: translations.qdYesterday },
    { value: "Last Week", label: translations.qdLastWeek },
    { value: "Last Month", label: translations.qdLastMonth },
  ];

  const futureOptions = [
    { value: "Tomorrow", label: translations.qdTomorrow },
    { value: "Next Week", label: translations.qdNextWeek },
    { value: "Next Month", label: translations.qdNextMonth },
  ];

  const optionsList = future
    ? [...commonOptions, ...futureOptions]
    : [...commonOptions.slice(0, 2), ...pastOptions, ...commonOptions.slice(2)];

  const handleChange = (e) => {
    const selectedValue = e.target.value;
    setQuickDate(selectedValue);

    const { from, to } = calculateDateRange(selectedValue);
    setFrom(from);
    setTo(to);
  };

  useEffect(() => {
    setQuickDate("All Time");
  }, [reset]);

  return (
    <select
      value={quickDate}
      className={`search_input ${className}`}
      onChange={handleChange}
      style={style}
    >
      <option value="All Time">{translations.qdAllTime}</option>
      {optionsList.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default QuickDatePicker;
